import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/number/is-nan';
import 'core-js/features/string/repeat';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TransformUtils from './common/utils/TransformUtils';

import './assets/styles/reset.css';
import './assets/styles/fonts.css';
import 'flickity/css/flickity.css';
import 'react-simple-keyboard/build/css/index.css';
// import 'react-image-gallery/styles/css/image-gallery.css';
import './index.css';

// const transformUtils = new TransformUtils();
// transformUtils.addEvent(window, 'resize', 'root');
// transformUtils.resize('root');

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
